export default __webpack_public_path__ + "static/media/Kenya.3bc2e3bf.png";